import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<Response, Body>({
    query: (body) => ({
      url: `v4/pitch-owner/tournaments/${body.tournamentId}/matches/${body.matchId}/list-target-swap-teams`,
      method: 'POST',
      body: body.body,
    }),
  });

interface Body {
  tournamentId: number;
  matchId: number;
  body: {
    current_team_id: number;
  };
}

interface Response {
  data: {
    teams: {
      id: number;
      name: string;
    }[];
  };
}
